import { dfApi as api } from '@services/df/baseApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        postV22FaSetup: build.mutation<PostV22FaSetupApiResponse, PostV22FaSetupApiArg>({
            query: queryArg => ({
                url: `/v2/2fa/setup/`,
                method: 'POST',
                body: queryArg.twoFactorAuthSetupRequestRequest,
            }),
        }),
        postV22FaVerify: build.mutation<PostV22FaVerifyApiResponse, PostV22FaVerifyApiArg>({
            query: queryArg => ({
                url: `/v2/2fa/verify/`,
                method: 'POST',
                body: queryArg.twoFactorAuthVerifyRequestRequest,
            }),
        }),
        authLoginOptionsCreate: build.mutation<AuthLoginOptionsCreateApiResponse, AuthLoginOptionsCreateApiArg>({
            query: queryArg => ({
                url: `/v2/auth/login/options/`,
                method: 'POST',
                body: queryArg.userLoginOptionsRequestRequest,
            }),
        }),
        obtainMagicLinkCreate: build.mutation<ObtainMagicLinkCreateApiResponse, ObtainMagicLinkCreateApiArg>({
            query: queryArg => ({ url: `/v2/obtain-magic-link/`, method: 'POST', body: queryArg.magicLinkRequest }),
        }),
        obtainAnonymousAuthTokenCreate: build.mutation<
            ObtainAnonymousAuthTokenCreateApiResponse,
            ObtainAnonymousAuthTokenCreateApiArg
        >({
            query: queryArg => ({
                url: `/v2/obtain_anonymous_auth_token/`,
                method: 'POST',
                body: queryArg.obtainAnonymousTokenRequest,
            }),
        }),
        obtainAuthTokenCreate: build.mutation<ObtainAuthTokenCreateApiResponse, ObtainAuthTokenCreateApiArg>({
            query: queryArg => ({
                url: `/v2/obtain_auth_token/`,
                method: 'POST',
                body: queryArg.obtainTokenRequestRequest,
            }),
        }),
        obtainS2STokenCreate: build.mutation<ObtainS2STokenCreateApiResponse, ObtainS2STokenCreateApiArg>({
            query: queryArg => ({ url: `/v2/obtain_s2s_token/`, method: 'POST', body: queryArg.obtainS2STokenRequest }),
        }),
        passwordRecoveryRequestCreate: build.mutation<
            PasswordRecoveryRequestCreateApiResponse,
            PasswordRecoveryRequestCreateApiArg
        >({
            query: queryArg => ({
                url: `/v2/password/recovery/request/`,
                method: 'POST',
                body: queryArg.requestResetPasswordRequest,
            }),
        }),
        passwordRecoveryResetCreate: build.mutation<
            PasswordRecoveryResetCreateApiResponse,
            PasswordRecoveryResetCreateApiArg
        >({
            query: queryArg => ({
                url: `/v2/password/recovery/reset/`,
                method: 'POST',
                body: queryArg.resetPasswordRequest,
            }),
        }),
        signupCreate: build.mutation<SignupCreateApiResponse, SignupCreateApiArg>({
            query: queryArg => ({ url: `/v2/signup/`, method: 'POST', body: queryArg.signUpRequest }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV22FaSetupApiResponse = /** status 200  */ TwoFactorAuthSetupResponse;
export type PostV22FaSetupApiArg = {
    twoFactorAuthSetupRequestRequest: TwoFactorAuthSetupRequestRequest;
};
export type PostV22FaVerifyApiResponse = /** status 200  */ TwoFactorAuthVerifyResponse;
export type PostV22FaVerifyApiArg = {
    twoFactorAuthVerifyRequestRequest: TwoFactorAuthVerifyRequestRequest;
};
export type AuthLoginOptionsCreateApiResponse = /** status 200  */ UserLoginOptions;
export type AuthLoginOptionsCreateApiArg = {
    userLoginOptionsRequestRequest: UserLoginOptionsRequestRequest;
};
export type ObtainMagicLinkCreateApiResponse = unknown;
export type ObtainMagicLinkCreateApiArg = {
    magicLinkRequest: MagicLinkRequest;
};
export type ObtainAnonymousAuthTokenCreateApiResponse = /** status 200  */ TokenResponseserializer;
export type ObtainAnonymousAuthTokenCreateApiArg = {
    obtainAnonymousTokenRequest: ObtainAnonymousTokenRequest;
};
export type ObtainAuthTokenCreateApiResponse = /** status 200  */ TokenResponseserializer;
export type ObtainAuthTokenCreateApiArg = {
    obtainTokenRequestRequest: ObtainTokenRequestRequest;
};
export type ObtainS2STokenCreateApiResponse = /** status 200  */ TokenResponseserializer;
export type ObtainS2STokenCreateApiArg = {
    obtainS2STokenRequest: ObtainS2STokenRequest;
};
export type PasswordRecoveryRequestCreateApiResponse = unknown;
export type PasswordRecoveryRequestCreateApiArg = {
    requestResetPasswordRequest: RequestResetPasswordRequest;
};
export type PasswordRecoveryResetCreateApiResponse = unknown;
export type PasswordRecoveryResetCreateApiArg = {
    resetPasswordRequest: ResetPasswordRequest;
};
export type SignupCreateApiResponse = /** status 200  */ TokenResponseserializer;
export type SignupCreateApiArg = {
    signUpRequest: SignUpRequest;
};
export type TwoFactorAuthSetupResponse = {
    qr_code_data_uri: string;
    secret: string;
    issuer_name: string;
    account_name: string;
};
export type TwoFactorAuthSetupRequestRequest = {
    company_name: string;
    email: string;
    password: string;
};
export type TwoFactorAuthVerifyResponse = {
    token: string;
    backup_codes?: string[];
};
export type TwoFactorAuthVerifyRequestRequest = {
    company_name: string;
    email: string;
    password: string;
    code: string;
};
export type AvailableLoginOptionsEnum = 'password' | 'sso';
export type UserLoginOptions = {
    available_login_options: AvailableLoginOptionsEnum[];
};
export type UserLoginOptionsRequestRequest = {
    company_name: string;
    email: string;
};
export type MagicLinkRequest = {
    email: string;
    company_name: string;
};
export type TokenResponseserializer = {
    token: string;
};
export type ObtainAnonymousTokenRequest = {
    company_name: string;
};
export type ObtainTokenRequestRequest = {
    company_name: string;
    email: string;
    password?: string;
    security_hash?: string;
};
export type ObtainS2STokenRequest = {
    api_key: string;
};
export type RequestResetPasswordRequest = {
    email: string;
    company_name?: string;
    redirect_path?: string;
};
export type ResetPasswordRequest = {
    reset_token: string;
    new_password: string;
};
export type SignUpRequest = {
    company_name: string;
    email: string;
    password: string;
    first_name?: string;
    last_name?: string;
    phone?: string;
    position?: string;
    company_title?: string;
};
export const {
    usePostV22FaSetupMutation,
    usePostV22FaVerifyMutation,
    useAuthLoginOptionsCreateMutation,
    useObtainMagicLinkCreateMutation,
    useObtainAnonymousAuthTokenCreateMutation,
    useObtainAuthTokenCreateMutation,
    useObtainS2STokenCreateMutation,
    usePasswordRecoveryRequestCreateMutation,
    usePasswordRecoveryResetCreateMutation,
    useSignupCreateMutation,
} = injectedRtkApi;
